import React, { ReactElement } from 'react';

import { millisecondsToDateString } from '../../utils/date';
// import Favourite from '../Buttons/Favourite';
import s from './Portfolio.module.scss';
import { useAuth } from '../Auth/AuthProvider';
import TrackableLink from '../TrackableLink';

interface TitleProps {
  id: number;
  name: string;
  zipCity: string;
  updatedAt: string;
}

export default function Title(props: TitleProps): ReactElement {
  const { id, name, zipCity, updatedAt } = props;
  // const [isFavourite, setFavourite] = useState(false);
  const { loggedIn } = useAuth();
  return (
    <div className={s.title}>
      <div className={s.titleCol}>
        <div className={s.header}>
          <span>{name}</span>
          <span className={s.tinyHeader}> {zipCity}</span>
          {/* <Favourite
            isFavourite={isFavourite}
            onClick={() => setFavourite(!isFavourite)}
          /> */}
        </div>
      </div>
      <div className={`${s.titleCol} ${s.hideOnBurger}`}>
        <div className={s.right}>
          {loggedIn && (
            <TrackableLink to={`/admin/project/edit/${id}`}>
              Bearbeiten
            </TrackableLink>
          )}
          <div>
            zuletzt aktualisiert am: {millisecondsToDateString(updatedAt)}
          </div>
        </div>
      </div>
    </div>
  );
}
